import { createTemplate } from "../template-helper";
import { uuidv4 } from "../../util/utils";

const COMPONENT_NAME = "z-repeat" ;


export default function register(){
    class RepeatComponent extends HTMLElement {
        constructor() {
            super();

            const templateId = uuidv4() ;

            this.template = document.getElementById(templateId);
            if(!this.template){
                this.template = createTemplate(templateId, this.innerHTML) ;
            }
            this.innerHTML = "" ;

            const clone = document.importNode(this.template.content, true);
            this.appendChild(clone);

            this.currentValue = [] ;
        }

        get value() {
            return this.currentValue ;
        }
        
        set value(value) {
            this.currentValue = value;
        }

        addOccurrence(){

        }

    }
    customElements.define(COMPONENT_NAME, RepeatComponent);
}
